export namespace EntityTypes {
  export namespace FinancialApplication {
    export const EntityType = "FinancialApplication";

    export namespace JointAccountOwner {
      export const EntityType = "JointAccountOwner";
    }

    export namespace KeyPerson {
      export const EntityType = "KeyPerson";
    }
  }

  const set = <T extends string>(...items: T[]): ReadonlySet<T> => new Set(items);

  export const Mapping: Readonly<Record<string, ReadonlySet<string>>> = {
    [FinancialApplication.EntityType]: set(
      FinancialApplication.EntityType,
      FinancialApplication.JointAccountOwner.EntityType,
      FinancialApplication.KeyPerson.EntityType
    ),
  };
}
